import { useEffect } from 'react';
import { fetchFinancialsFromApi } from '../properties';
import { useApiFetch } from './useApiFetch';

export function useFetchFinancials(property) {
  const fanancialsApi = useApiFetch(fetchFinancialsFromApi);

  useEffect(() => {
    if (!property?.boligmappaNumber) return;

    const { boligmappaNumber } = property;
    fanancialsApi.executeFetch(boligmappaNumber);
  }, [property?.boligmappaNumber]);

  return {
    data: fanancialsApi.data,
    error: fanancialsApi.error,
    executeFetch: fanancialsApi.executeFetch,
    isLoading: fanancialsApi.isLoading,
  };
}
